// https://developers.google.com/analytics/devguides/collection/gtagjs/events
import $ from "jquery"

const gtagScriptsTemplate = `
        <!-- Global site tag (gtag.js) - Google Analytics -->
        <script async src="https://www.googletagmanager.com/gtag/js?id={{ID}}"></script>
        <script>
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', '{{ID}}');
        </script>
    `


function init (id) {
    const gtagScripts = gtagScriptsTemplate.replace(/{{ID}}/gi, id)
    $("head").prepend(gtagScripts)
}


function emit (...args) {
    window.gtag("event", ...args)
}


export default {
    init,
    emit
}
